import styled from "styled-components";

import theme from "config/theme";

import StyledImage from "components/Image";

export const Image = styled(StyledImage)`
  display: block;
  width: 100%;
  margin: 0 auto 0 80px;
  max-width: 65%;

  @media (max-width: ${theme.size.desktop}) {
    margin: 0;
    max-width: calc(100% - 50px);
  }

  @media (max-width: ${theme.size.tablet}) {
    margin: 0 auto 30px;
    max-width: 350px;
  }

  @media (max-width: ${theme.size.mobile}) {
    max-width: 300px;
  }
`;
